//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
export default {
     components: {
        cmBlank
    },
    data(){
        return {
            cid:0,
            title:'',
            list:[],
            where:[],
            price:[],
        }
    },
    mounted(){
        this.cid = parseInt(this.$route.params.cid);
        this.getList();
    },
    methods: {
        reset(){
            this.title = '';
            this.list = [];
            this.getList();
        },
        search(){
            this.list = [];
            this.getList();
        },
        getList(){
            this.$api.storeGoodsPrice({cid:this.cid,title:this.title}).then((res)=>{
                if(res){
                    this.list = res.data;
                }
            })  
        },
        submit(i){
            console.log(i,this.price[i]);
            let price = Number(this.price[i]);
            let miPrice = Number(this.list[i].mi_wash_price);
            if(miPrice != price){
                // if(miPrice < price){
                //     this.$func.showToast('下级加工价格不能小于平台加工价格');
                //     return false;
                // }
                this.$api.submitStoreGoodsPrice({cid:this.cid,gid:this.list[i].id,price:price}).then((res)=>{
                    if(res){
                        // this.search();
                        this.list[i].wash_price = price;
                        this.$func.showToast('提交成功');
                    }
                })  
            }
            // this.$api.storeGoodsPrice({title:this.title}).then((res)=>{
            //     if(res){
            //         this.list = res.data;
            //     }
            // })  
        },
    },
}



// WEBPACK FOOTER //
// ./src/pages/secondCommunityFactoryPrice.vue